import Marquee from "react-fast-marquee";

const WORDS = ["MARKETING", "BRANDING", "DEVELOPMENT", "STRATEGY", "GROWTH", "DESIGN"];

export const EditorialMarquee = () => {
  return (
    <section
      data-testid="marquee"
      className="relative border-y border-white/10 bg-[#000000] py-10 md:py-14"
    >
      <Marquee speed={45} gradient={false} autoFill>
        {WORDS.map((w, i) => (
          <span key={i} className="mx-8 flex items-center gap-8">
            <span className="text-stroke font-display text-6xl font-extrabold tracking-tight md:text-8xl">
              {w}
            </span>
            <span className="h-3 w-3 rounded-full bg-white" />
          </span>
        ))}
      </Marquee>
    </section>
  );
};

export default EditorialMarquee;
